import { Scene } from '../Scene';
import { LiquidVolumeRef, SceneManifest } from '../SceneManifest';
import { LiquidSurface } from '../../object/primitives/LiquidSurface';
import {
  PolygonVertex,
  tessellateLiquidPolygon,
} from '../../object/primitives/liquid-polygon-tessellator';
import { SceneLoadProgressTracker } from '../SceneLoadProgress';

export async function loadEffects(
  scene: Scene,
  manifest: SceneManifest,
  tracker?: SceneLoadProgressTracker,
): Promise<void> {
  if (!manifest.effects?.length) return;

  const effects = manifest.effects;
  for (let i = 0; i < effects.length; i++) {
    tracker?.updateStageProgress(i / Math.max(1, effects.length), effects[i].id);
    const ref = effects[i];
    if (ref.kind !== 'liquidVolume') continue;
    loadLiquidVolume(scene, ref);
  }
}

function loadLiquidVolume(scene: Scene, ref: LiquidVolumeRef): void {
  if (!ref.polygon || ref.polygon.length < 3) {
    console.warn(`Liquid volume '${ref.id}' has no polygon (need ≥3 vertices)`);
    return;
  }

  const polygon: PolygonVertex[] = ref.polygon.map(([x, z]) => [x, z] as const);
  const geom = tessellateLiquidPolygon(polygon, ref.fillY);

  const surface = LiquidSurface.fromGeometry(
    scene.ctx,
    {
      positions: geom.positions,
      texCoords: geom.texCoords,
      indices: geom.indices,
      edgeDistance: geom.edgeDistance,
    },
    {
      color: ref.color as [number, number, number, number],
      opacity: ref.opacity,
      amplitude: ref.amplitude,
      waveSpeed: ref.waveSpeed,
      waveDirection: ref.waveDirection as [number, number],
      texture: ref.texture ? scene.textureCache.getTexture(ref.texture) : undefined,
      shoreFadeDistance: ref.shoreFadeDistance,
      shoreDepthFade: ref.shoreDepthFade,
      glintRoughness: ref.glintRoughness,
    },
  );
  surface.setPosition(0, 0, 0);
  scene.objectManager.addObject(surface);
}
